(()=>{if(window.furlabV1Loaded)return;window.furlabV1Loaded=true;document.addEventListener('click',e=>{const open=e.target.closest('[data-furlab-help-open]');const close=e.target.closest('[data-furlab-help-close]');const dialog=document.getElementById('furlab-material-help');if(!dialog)return;if(open){e.preventDefault();if(!dialog.open)dialog.showModal()}if(close)dialog.close();if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});const setup=()=>{const dialog=document.getElementById('furlab-material-help');if(dialog&&dialog.parentElement!==document.body)document.body.appendChild(dialog);if(location.search.includes('contact_posted=true')&&location.hash.includes('FurlabMaterialContact')&&dialog&&!dialog.open)dialog.showModal()};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup)})();
/* Furlab wholesale tier modal: reuses the live quantity-break table when present. */
(()=> {
  if (window.__FURLAB_WHOLESALE_MODAL__) return;
  window.__FURLAB_WHOLESALE_MODAL__ = true;
  const findTierTable = () => Array.from(document.querySelectorAll('table')).find(table => {
    const t = (table.textContent || '').toLowerCase();
    return t.includes('quantity') && (t.includes('discount') || t.includes('price applied'));
  });
  const ensureDialog = () => {
    let dialog = document.getElementById('flv1-wholesale-dialog');
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.id = 'flv1-wholesale-dialog';
    dialog.innerHTML = '<div class="flv1-wholesale-modal__head"><h3>Wholesale pricing</h3><button type="button" class="flv1-wholesale-modal__close" aria-label="Close">×</button></div><div class="flv1-wholesale-modal__body"><p class="flv1-wholesale-modal__fallback">Quantity discounts are shown here when available for this product.</p></div>';
    document.body.appendChild(dialog);
    dialog.querySelector('.flv1-wholesale-modal__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    return dialog;
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.flv1-wholesale-trigger, .bss-custom-login-message');
    if (!trigger) return;
    event.preventDefault(); event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    const dialog = ensureDialog();
    const body = dialog.querySelector('.flv1-wholesale-modal__body');
    body.innerHTML = '';
    const table = findTierTable();
    if (table) {
      const intro = document.createElement('p');
      intro.className = 'flv1-wholesale-modal__intro';
      intro.textContent = 'Quantity discounts for this product';
      body.appendChild(intro);
      const clonedTable = table.cloneNode(true);
      clonedTable.style.display = '';
      clonedTable.removeAttribute('data-flv1-hidden');
      body.appendChild(clonedTable);
    } else {
      const fallback = document.createElement('p');
      fallback.className = 'flv1-wholesale-modal__fallback';
      fallback.textContent = 'Wholesale quantity pricing is available for eligible orders. Please sign in or contact Furlab for the current tier prices.';
      body.appendChild(fallback);
    }
    if (!dialog.open) dialog.showModal();
  }, true);
})();

/* Furlab: hide inline wholesale table, make modal tiers selectable, and estimate rates from Shopify's current cart. */
(()=> {
  if (window.__FURLAB_PRODUCT_INTERACTIONS_V2__) return;
  window.__FURLAB_PRODUCT_INTERACTIONS_V2__ = true;

  const getTierTable = () => Array.from(document.querySelectorAll('table')).find(table => {
    if (table.closest('#flv1-wholesale-dialog')) return false;
    const t = (table.textContent || '').toLowerCase();
    return t.includes('quantity') && t.includes('discount') && (t.includes('price applied') || t.includes('buy 6'));
  });

  const hideInlineTierTable = () => {
    const table = getTierTable();
    if (!table) return;
    const widget = table.closest('.bss-b2b-cart-item-qty-table');
    if (widget && widget.dataset.flv1TierHidden !== 'true') widget.dataset.flv1TierHidden = 'true';
    if (table.dataset.flv1Hidden === 'true') return;
    table.dataset.flv1Hidden = 'true';
    table.style.display = 'none';
    let parent = table.parentElement;
    for (let i=0; i<3 && parent; i++, parent=parent.parentElement) {
      const txt = (parent.innerText || '').trim();
      if (txt.length < 500 && /常规批发阶梯价|quantity discount|discount details/i.test(txt)) {
        parent.querySelectorAll('h1,h2,h3,h4,p,div,span').forEach(el => {
          if (el.children.length === 0 && /常规批发阶梯价|quantity discount|discount details/i.test(el.textContent.trim())) el.style.display='none';
        });
      }
    }
    const heading = Array.from(document.querySelectorAll('h1,h2,h3,h4,p,div,span')).find(el => el.children.length===0 && el.textContent.trim()==='常规批发阶梯价');
    if (heading) heading.style.display='none';
  };

  const setQuantity = quantity => {
    const form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('product-form form') || document;
    const input = form.querySelector('input[name="quantity"], input[id*="Quantity"], input[type="number"][name="quantity"]') || document.querySelector('input[name="quantity"]');
    if (!input) return false;
    input.value = String(quantity);
    input.dispatchEvent(new Event('input',{bubbles:true}));
    input.dispatchEvent(new Event('change',{bubbles:true}));
    input.dispatchEvent(new Event('blur',{bubbles:true}));
    const box = input.closest('.hdt-quantity-wrapp, .hdt-quantity, quantity-input, .quantity') || input;
    box.scrollIntoView({behavior:'smooth',block:'center'});
    input.focus({preventScroll:true});
    return true;
  };

  document.addEventListener('click', event => {
    const row = event.target.closest('#flv1-wholesale-dialog tbody tr');
    if (!row) return;
    const first = row.cells && row.cells[0] ? row.cells[0].innerText : '';
    const match = first.match(/(?:buy|购买)\s*(\d+)/i);
    if (!match) return;
    const quantity = Number(match[1]);
    if (!Number.isFinite(quantity) || quantity < 1) return;
    if (setQuantity(quantity)) {
      const dialog = document.getElementById('flv1-wholesale-dialog');
      if (dialog && dialog.open) dialog.close();
    }
  });

  const initShippingEstimator = () => {
    document.querySelectorAll('[data-flv1-shipping-estimator]').forEach(form => {
      if (form.dataset.flv1Bound === 'true') return;
      form.dataset.flv1Bound = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const status = form.querySelector('[data-flv1-shipping-results]');
        const data = new FormData(form);
        const address = {
          country: String(data.get('country')||'').trim(),
          city: String(data.get('city')||'').trim(),
          province: String(data.get('province')||'').trim()
        };
        if (!address.country || !address.city) {
          status.textContent = 'Please enter your country and city.';
          return;
        }
        const params = new URLSearchParams({
          'shipping_address[country]':address.country,
          'shipping_address[city]':address.city,
          'shipping_address[province]':address.province
        });
        const button=form.querySelector('button[type="submit"]');
        const original=button.textContent;
        button.disabled=true;button.textContent='Calculating…';
        status.textContent='Checking rates with the store shipping service…';
        try {
          const prep=await fetch('/cart/prepare_shipping_rates.json?'+params.toString(),{method:'POST',credentials:'same-origin'});
          if(!prep.ok) {
            let message='Unable to prepare shipping rates. Add this product to your cart, then try again.';
            try { const err=await prep.json(); if(err && err.description) message=err.description; } catch(e) {}
            throw new Error(message);
          }
          let rates=null;
          for(let attempt=0;attempt<12;attempt++){
            await new Promise(resolve=>setTimeout(resolve,700));
            const response=await fetch('/cart/async_shipping_rates.json?'+params.toString(),{credentials:'same-origin'});
            if(!response.ok) continue;
            const result=await response.json();
            if(result && Array.isArray(result.shipping_rates)){rates=result.shipping_rates;break;}
          }
          if(!rates) throw new Error('Shipping rates are taking longer than expected. Please try again at checkout.');
          if(!rates.length){status.textContent='No shipping methods are available for this destination and cart. Please contact us for help.';return;}
          const list=document.createElement('ul');
          list.className='flv1-shipping-estimator__rate-list';
          rates.forEach(rate=>{
            const li=document.createElement('li');
            const name=document.createElement('span');name.textContent=rate.presentment_name||rate.name||'Shipping';
            const price=document.createElement('strong');
            const amount=Number(rate.price);
            price.textContent=Number.isFinite(amount)?amount.toFixed(2)+' '+(rate.currency||window.Shopify?.currency?.active||'USD'):'See at checkout';
            li.append(name,price);list.appendChild(li);
          });
          status.innerHTML='';
          const heading=document.createElement('strong');heading.className='flv1-shipping-estimator__result-title';heading.textContent='Available shipping rates';status.append(heading,list);
          const note=document.createElement('p');note.className='flv1-shipping-estimator__note';note.textContent='Final shipping is confirmed at checkout. Rates reflect all items currently in your cart.';status.appendChild(note);
        } catch(error) {
          status.textContent=error.message||'Unable to calculate shipping. Please check your address and try again.';
        } finally {
          button.disabled=false;button.textContent=original;
        }
      });
    });
  };

  const init=()=>{hideInlineTierTable();initShippingEstimator();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  const observer=new MutationObserver(()=>init());
  observer.observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',init);
})();


/* Furlab product-page tools: four random picks from the best-selling Grooming collection. */
(()=> {
  if(window.__FLV1_TOOL_RECOMMENDATIONS__)return;
  window.__FLV1_TOOL_RECOMMENDATIONS__=true;
  const pickFour=()=>{
    const section=document.querySelector('#related-products');
    if(!section)return;
    const container=section.querySelector('.hdt-slider__container');
    if(!container)return;
    const cards=Array.from(container.children).filter(el=>el.matches('.hdt-slider__slide'));
    if(cards.length<=4)return;
    const pool=cards.slice();
    for(let i=pool.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]];}
    const chosen=pool.slice(0,4);
    cards.forEach(card=>{card.hidden=!chosen.includes(card);});
    chosen.forEach(card=>container.appendChild(card));
  };
  const init=()=>requestAnimationFrame(pickFour);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  setTimeout(init,500);
  setTimeout(init,1500);
})();
